export default __webpack_public_path__ + "static/media/docusign.9e771eb2.png";